import { mergeAttributes, Node } from '@tiptap/core'
import { ReactNodeViewRenderer } from '@tiptap/react'
import OEmbedComponent from './OEmbedComponent'

const OEmbedExtension = Node.create({
  name: 'oembed',

  group: 'block',
  atom: true,

  addAttributes() {
    return {
      url: {
        default: '',
      },
      data: {
        default: null,
        parseHTML: element => {
          const data = element.getAttribute('data-oembed')
          return data ? JSON.parse(data) : null
        },
        renderHTML: attrs => ({
          'data-oembed': attrs.data ? JSON.stringify(attrs.data) : '',
        }),
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'oembed-block',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['oembed-block', mergeAttributes(HTMLAttributes)]
  },

  addNodeView() {
    return ReactNodeViewRenderer(OEmbedComponent)
  },
})

export default OEmbedExtension
